import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FormSelect extends Component {
  handleChange = (name, e) => {
    e.preventDefault();
    const { onChange, options, type } = this.props;
    const newOption = options.find((o) => o.value === e.target.value);

    if (newOption) {
      onChange({
        name,
        type,
        value: newOption.value,
      });
    }
  };

  render() {
    const {
      options,
      disabled,
      placeholder,
      label,
      name,
      error,
      value,
      required,
      onFocus = () => {},
    } = this.props;
    // Set optionItems as a const, maps the options array with objects, loops and prints them out
    const optionItems =
      options &&
      options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.name}
        </option>
      ));
    return (
      <FormControl
        disabled={disabled}
        error={Boolean(error)}
        fullWidth
        required={required}
      >
        <InputLabel data-id={name} htmlFor="form-select" shrink>
          {label}
        </InputLabel>
        <Select
          data-id={name}
          displayEmpty
          input={<Input id="form-select" />}
          native
          onChange={(e) => this.handleChange(name, e)}
          onFocus={onFocus}
          placeholder={placeholder}
          value={value}
        >
          <option disabled value="">
            {placeholder}
          </option>
          {optionItems}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
  }
}

FormSelect.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
    }),
  ).isRequired,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
};

FormSelect.defaultProps = {
  disabled: false,
  error: undefined,
  onFocus: () => {},
  required: false,
  value: '',
};

export default FormSelect;
